module.exports = __webpack_public_path__ + "img/download-all.7445d481.svg";